import React from 'react';
import EventFeeds from './EventFeeds.jsx';
import { useSelector } from 'react-redux';

export const EVENT_FEED_TYPES = ["application", "report", "survey", "disbursement", "deadline", "support", "programme_live_discussion", "project_live_discussion", "match_basket"];

function EventFeedWidget({ widgetId }) {
    const filters = useSelector(state => state.dashboard.widgets[widgetId].settings);
    const showProfilePics = useSelector(state => state.dashboard.showProfilePics);
    const projectId = useSelector(state => state.dashboard.projectId);

    return (
        <div className='event-feeds-widget' style={{padding: '10px', paddingTop: '20px', height: '100%'}}>
            <EventFeeds
                eventFeedTypes={EVENT_FEED_TYPES}
                selectedFilters={filters}
                showProfilePics={showProfilePics}
                projectId={projectId}
            />
        </div>
    );
}

export default EventFeedWidget;
